import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { RemoveEmailSubscriberConfirmationModalComponent } from './remove-email-subscriber-confirmation-modal.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [RemoveEmailSubscriberConfirmationModalComponent],
})
export class RemoveEmailSubscriberConfirmationModalModule {}
